import React, { useCallback, useContext } from 'react';

import Button from 'Common/Button';

import { AnalysisContext } from '../../analysis.context';
import AnalysisForm from '../forms/AnalysisForm';

export default function Add() {
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(AnalysisContext);
  const closeDialog = useCallback(
    success => {
      setNewDialogOpened(false);

      if (success) {
        reload();
      }
    },
    [reload, setNewDialogOpened]
  );

  const onClick = () => {
    setNewDialogOpened(true);
  };
  return (
    <>
      <Button className="mt-1 ml-1" color="primary" variant="contained" value="Tahlil/Tetkik Ekle" onClick={onClick}>
        Tahlil/Tetkik Ekle
      </Button>

      <AnalysisForm onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
